import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-minus\"><path fill=\"none\" d=\"M0 0h16v16H0z\" /><path d=\"M4 7.5h8v1H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol